<template>
  <div class="container">
    <headComponent/>
    <main class="content">
      <h1>Edit Link</h1>
      <form @submit.prevent="confirmAndUpdateLink">

        <div class="row">
          <div class="col"></div>
          <div class="col">
            <div class="form-group">
              <label for="original_link">Original Link</label>
              <input
                  type="text"
                  id="original_link"
                  class="form-control"
                  v-model="link.original_link"
                  :placeholder="url"
                  required
              />
            </div>
          </div>
          <div class="col"></div>
        </div>
        <button type="submit" class="btn btn-primary">Save Changes</button>
      </form>
    </main>
    <FooterComponent/>
  </div>
</template>

<script>
import {updateLink} from "@/services/links/linkUpdateService.js";

import FooterComponent from "@/components/views/footer/FooterComponent.vue";
import HeadComponent from "@/components/views/head/HeadComponent.vue";


export default {
  name: "LinkformComponent",
  /**
   * Object containing Vue.js components that can be used in the template.
   * These components are pre-registered for use within the parent component or view.
   *
   * Properties:
   * - `HeadComponent`: The component responsible for rendering the header section.
   * - `FooterComponent`: The component responsible for rendering the footer section.
   */
  components: {
    HeadComponent,
    FooterComponent,
  },
  /**
   * Provides an object containing the initial state data for the component.
   *
   * @return {Object} The data object, which includes:
   * - `link`: An object with `original_link` initialized as an empty string.
   * - `url`: A value retrieved from the query parameter `url` in the current route.
   */
  data() {
    return {
      link: {
        original_link: "",
      },
      url: this.$route.query.url,
    };
  },
  /**
   * Displays a confirmation dialog to the user using SweetAlert. If the confirmation is made,
   * it updates a specified link by calling the `updateLink` function with provided parameters.
   *
   * @method confirmAndUpdateLink
   * @async
   * @returns {Promise<void>} Resolves when the update operation is completed or canceled.
   */
  methods: {
    /**
     * Handles the confirmation process for updating a link.
     * Displays a confirmation dialog to the user, and if confirmed, updates the provided link.
     *
     * @return {Promise<void>} Resolves when the confirmation dialog is completed and the link is updated if confirmed.
     */
    async confirmAndUpdateLink() {
      const result = await this.$swal({
        title: '¿Estás seguro?',
        text: "Se guardarán los cambios realizados.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        await updateLink(this.$route.query.link, this.link.original_link, this.$router, this.$swal);      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

input::placeholder {
  color: #a9a9a9;
}
</style>
